module.exports = __webpack_public_path__ + "assets/img/buy_word_course2.0eb01834.png";